import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/effective-annual-rate',
  component: () => import('../../routes/NominalEffective.svelte'),
  card: {
    id: 'effective-annual-rate',
    title: 'Effective Annual Rate (EAR)',
    description: 'Calculate the true annual yield by accounting for compounding frequency. Compare investments and loans accurately.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/effective-annual-rate',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Effective Annual Rate (EAR) Calculator – True Annual Yield',
    description: 'Free EAR calculator. Calculate the effective annual rate from a nominal rate and compounding frequency. Compare investments accurately using the true annual yield.',
  },
};

export default meta;
